document.addEventListener('DOMContentLoaded', () => {
  // アンカーリンク要素を全て選択
  const anchorLinks = document.querySelectorAll(
    'a[href^="#"]'
  ) as NodeListOf<HTMLAnchorElement>;

  // バッファの値を設定（例：50px）
  const buffer = 50;

  // 各リンクに対してイベントリスナーを追加
  anchorLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      // デフォルトのイベントをキャンセル（ページが突然移動するのを防ぐ）
      event.preventDefault();

      // リンクのhref属性からアンカーのIDを取得
      const anchorId = link.getAttribute('href') || '';

      // 対象のアンカー要素を選択
      const targetElement = document.querySelector(anchorId) as HTMLElement;

      // アンカー要素の位置までスムーズにスクロール（バッファを考慮）
      window.scrollTo({
        top:
          window.pageYOffset +
          targetElement.getBoundingClientRect().top -
          buffer,
        behavior: 'smooth', // アニメーション効果を指定
      });
    });
  });
});
